/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Capability_Contracts_HintInputs */



/**
* | output |
* | --- |
* | "Put a customer on a fixed price for a fixed term against a signed order — agreed seats and a prepaid usage budget instead of pay-per-use." |
*
* @param {Partner_Admin_Capability_Contracts_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_capability_contracts_hint = /** @type {((inputs?: Partner_Admin_Capability_Contracts_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Capability_Contracts_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einen Kunden auf einen Festpreis für eine feste Laufzeit gegen eine unterschriebene Bestellung setzen — vereinbarte Plätze und ein vorausbezahltes Nutzungsbudget statt nutzungsbasierter Abrechnung.")
	return /** @type {LocalizedString} */ ("Put a customer on a fixed price for a fixed term against a signed order — agreed seats and a prepaid usage budget instead of pay-per-use.")
});